import styled from 'styled-components'
import { useState } from 'react'

import { Checkbox, Label } from 'components'

const Container = styled.div`
  margin: 1rem;
`
export const Details = ({ onChange }) => {
  return (
    <Container>
      <Checkbox label="collidable" onChange={onChange} />
    </Container>
  )
}
